import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Product } from '../types';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateItemPrice(product: Product, variantId?: string, userRole?: string): number {
  let price: number | string = product.pvpDiscount || product.pvp || (product as any).price || 0;
  
  const isProfessional = userRole && userRole !== 'guest';
  const canSeePvr = isProfessional && (product.pvr || (variantId && product.variants?.find(v => v.id === variantId)?.pvr)) && product.allowedPvrProfiles?.includes(userRole as any);
  const isFlashActive = product.flashOffer && new Date(product.flashOffer.expiresAt) > new Date();

  if (variantId && product.variants) {
    const variant = product.variants.find(v => v.id === variantId);
    if (variant) {
      price = canSeePvr ? (variant.pvr || product.pvr || 0) : (isFlashActive ? (product.flashOffer?.discountPvp || 0) : (variant.pvpDiscount || variant.pvp || (product as any).price || 0));
    }
  } else {
    price = canSeePvr ? (product.pvr || 0) : (isFlashActive ? (product.flashOffer?.discountPvp || 0) : (product.pvpDiscount || product.pvp || (product as any).price || 0));
  }
  
  if (typeof price === 'string') price = (price as string).replace(',', '.');
  return Number(price) || 0;
}
